import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react';
import SessionSelectionModal from './sessions';
import useApi from '../hooks/use-api';
import TicketSelectionModal from './tickets';
import LoaderModal from '../../components/loader';
import ErrorModal from './error';
import openLinkInNewTab from '../../utils/openLinkInNewTab';

const ChooseYourPrice = observer(({ store }) => {
  const [settings, setSettings] = useState(null);
  const [sessionConfig, setSessionConfig] = useState(null);
  const [loaderText, setLoaderText] = useState('Loading sessions');
  const [apiErrorMessage, setApiErrorMessage] = useState(null);
  const [ticketPurchaseError, setTicketPurchaseError] = useState(null);
  const api = useApi();

  useEffect(() => {
    store.setLoading(true);
    api.getSessions(store.eventId).then(({ apiError, response }) => {
      if (apiError) {
        setApiErrorMessage('We\'re not able to load sessions at this time. Please try again later.');
      } else {
        store.setSessions(response.sessions);
        setSettings(response.settings);
      }
      store.setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (store.chosenSession) {
      setLoaderText('Checking ticket options');
      store.setLoading(true);
      api.getShowingDetails(store.eventId, store.chosenSession.choose_your_price_showing_id).then(({ apiError, response }) => {
        if (apiError) {
          setApiErrorMessage('We\'re not able to load tickets at this time. Please try again later.');
        } else if (response.available) {
          if (response.tickets && response.tickets.ticket_options.length) {
            store.setTickets(response.tickets.ticket_options);
          } else if (response.primary_tickets && response.primary_tickets.length) {
            store.setTickets(response.primary_tickets);
          } else {
            setApiErrorMessage('We couldn\'t find any available tickets for this session.');
          }
          setSessionConfig(response.session_config);
        } else {
          setApiErrorMessage('We couldn\'t find any available tickets for this session.');
        }

        store.setLoading(false);
      });
    }
  }, [store.chosenSession]);

  useEffect(() => {
    if (store.numTickets && store.chosenTicket) {
      setLoaderText('Prepping you for iticket');
      store.setLoading(true);
      api.purchaseTickets(store.eventId, store.chosenSession.choose_your_price_showing_id, store.numTickets, store.chosenTicket).then(({ apiError, response }) => {
        if (apiError) {
          setApiErrorMessage('We were unable to process your ticket purchase. Please try again later');
          store.setLoading(false);
        } else if (response.sold_out) {
          setTicketPurchaseError('Sorry, it looks like you just missed out. Please select another ticket.');
          store.setLoading(false);
        } else if (response.ticket_limit_reached) {
          setApiErrorMessage((<>You've reached your ticket limit for this session. Return to your <a href={ response.iticket_cart }>iTicket cart</a>.</>));
          store.setLoading(false);
        } else {
          window.location = response.redirect_to;
        }
      });
    }
  }, [store.numTickets]);

  const handleSessionSelection = (session) => {
    if (!session.is_choose_your_price_session) {
      if (session.booking_url) {
        openLinkInNewTab(session.booking_url, true);
      } else {
        openLinkInNewTab(store.bookingUrl, true);
      }
      window.location = window.location.href;
      // close the modal and reset state... by making ChooseYourPrice return null
      // store.setLoading(false);
      // store.setSessions([]);
      // store.setTickets(false);
    } else {
      store.setChosenSession(session);
    }
  };

  const handleTicketPurchase = (numTickets, ticketOption) => {
    store.setNumTickets(numTickets);
    store.setChosenTicket(ticketOption);
  };

  if (store.isLoading) {
    return (
      <LoaderModal messageText={ loaderText } />
    );
  }

  if (apiErrorMessage) {
    return (
      <ErrorModal errorMessage={ apiErrorMessage }  closeModal={ closeModal } />
    );
  }

  if (store.hasTickets) {
    return (
      <TicketSelectionModal
        eventName={ store.eventName }
        tickets={ store.getTickets }
        settings={ settings }
        session={ store.chosenSession }
        sessionConfig={ sessionConfig }
        handleTicketPurchase={ handleTicketPurchase }
        ticketPurchaseError={ ticketPurchaseError }
      />
    );
  }

  if (store.hasSessions) {
    return (
      <SessionSelectionModal
        sessions={ store.getSessions }
        settings={ settings }
        handleSessionSelection={ handleSessionSelection }
      />
    );
  }
  return null;
});

export default ChooseYourPrice;
